import { useContext, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "./style.css";
import { CategoryContext } from "../../context/categories";
import { TagsContext } from "../../context/tag";

const CreateBoxModal = ({ show, onClose, onSubmit, locations }) => {
  const [formData, setFormData] = useState({
    box_name: "",
    name_in_view: "",
    box_priority: 0,
    item_count: 0,
    box_location_id: null,
    categorys: null,
    tags: null,
    content_type: "",
    cach_time: 0,
    box_item_type: "by hand",
    status: true,
  });
  const { categories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
    setFormData({
      box_name: "",
      name_in_view: "",
      box_priority: 0,
      item_count: 0,
      box_location_id: null,
      categorys: null,
      tags: null,
      content_type: "",
      cach_time: 0,
      box_item_type: "atuo",
      status: true,
    });
  };

  if (!show) return null;

  return (
    <div className="modal-backdrop show">
      <div className="modal d-block" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد باکس جدید</h5>

              <button type="button" className="close" onClick={onClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <Row>
                  <Col md={6}>
                    <label>نام باکس</label>
                    <input
                      className="form-control"
                      value={formData.box_name}
                      onChange={(e) => handleChange("box_name", e.target.value)}
                    />
                  </Col>
                  <Col md={6}>
                    <label>نام نمایشی</label>
                    <input
                      className="form-control"
                      value={formData.name_in_view}
                      onChange={(e) =>
                        handleChange("name_in_view", e.target.value)
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>اولویت</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.box_priority}
                      onChange={(e) =>
                        handleChange("box_priority", Number(e.target.value))
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <label>تعداد کارت</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.item_count}
                      onChange={(e) =>
                        handleChange("item_count", Number(e.target.value))
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <label>مدت کش</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.cach_time}
                      onChange={(e) =>
                        handleChange("cach_time", Number(e.target.value))
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={6}>
                    <label>مکان</label>
                    <select
                      className="form-control"
                      value={formData.box_location_id || ""}
                      onChange={(e) =>
                        handleChange("box_location_id", Number(e.target.value))
                      }
                    >
                      <option value="">-- انتخاب --</option>
                      {locations.map((loc) => (
                        <option key={loc.id} value={loc.id}>
                          {loc.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label>نوع محتوا</label>
                    <select
                      className="form-control"
                      value={formData.content_type || ""}
                      onChange={(e) =>
                        handleChange("content_type", e.target.value)
                      }
                    >
                      <option value="">-- انتخاب --</option>
                      {["video", "channel", "audio", "campaign"].map(
                        (item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        )
                      )}
                    </select>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={6}>
                    <label>دسته بندی</label>
                    <select
                      className="form-control"
                      value={formData.categorys || ""}
                      onChange={(e) =>
                        handleChange("categorys", Number(e.target.value))
                      }
                    >
                      <option value="">-- انتخاب --</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label>تگ</label>
                    <select
                      className="form-control"
                      value={formData.tags || ""}
                      onChange={(e) => handleChange("tags", e.target.value)}
                    >
                      <option value="">-- انتخاب --</option>
                      {tags?.results?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={6}>
                    <label>مقداردهی</label>
                    <select
                      className="form-control"
                      value={formData.box_item_type}
                      onChange={(e) =>
                        handleChange("box_item_type", e.target.value)
                      }
                    >
                      <option value="by hand">دستی</option>
                      <option value="atuo">اتوماتیک</option>
                    </select>
                  </Col>
                  <Col md={6}>
                    <label>وضعیت</label>
                    <select
                      className="form-control"
                      value={formData.status}
                      onChange={(e) =>
                        handleChange("status", e.target.value === "true")
                      }
                    >
                      <option value="true">فعال</option>
                      <option value="false">غیرفعال</option>
                    </select>
                  </Col>
                </Row>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                بستن
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                ایجاد
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBoxModal;
